import { render, staticRenderFns } from "./ContentHomeWork.vue?vue&type=template&id=ab72ba40&scoped=true"
import script from "./ContentHomeWork.vue?vue&type=script&lang=js"
export * from "./ContentHomeWork.vue?vue&type=script&lang=js"
import style0 from "./ContentHomeWork.vue?vue&type=style&index=0&id=ab72ba40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab72ba40",
  null
  
)

export default component.exports